import { BaseListViewStore, BulkPrintHistoryNameTooltipCellData, DateTimeCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { BulkPrintHistoryStore } from 'modules/order/stores';
import { ConfirmModalParams } from 'core/models';
import { notificationError, createFileUrl } from 'core/utils';
import { BulkPrintHistoryForm } from '../forms';
import moment from 'moment';
import { sourceOfChange } from 'common/constants';

class BulkPrintHistoryViewStore extends BaseListViewStore {
	@observable change = false;
	@observable pdfURL = null;
	selectedItem = null;
	printPdf = false;

	form = new BulkPrintHistoryForm({
		onSuccess: async () => {
			await this.createBulkPrintHistory();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore, {
			isModalListView: true,
			listStore: new BulkPrintHistoryStore(rootStore),
			queryParams: {
				embed: ['bulkPrintHistoryItems', 'bulkPrintHistoryItems.fulfillmentOrder'],
				filter: null,
				ignore: true,
				pageSize: 10,
			},
			findFunction: 'findBulkPrintHistory',
			tableData: {
				columns: [
					{
						key: 'name',
						title: 'FULFILLMENTORDER.BULKPRINT.NAME',
						dataCell: BulkPrintHistoryNameTooltipCellData,
						ellipsis: true,
						width: 200,
						sortable: true,
					},
					{
						key: 'numberOfFulfillmentOrders',
						title: 'FULFILLMENTORDER.BULKPRINT.NOOFORDERS',
						sortable: true,
					},
					{
						key: 'dateCreated',
						title: 'FULFILLMENTORDER.BULKPRINT.DATECREATED',
						sortable: true,
						dataCell: DateTimeCellData,
						useLocalTime: true,
						width: 200,
						format: 'LLL',
					},
				],
				sortObject: [],
				actions: {
					onDelete: async item => this.openConfirmationModal(this.getDeleteConfirmModalProps(item)),
					onPrintBulkHistory: async item => this.printBulkHistory(item),
				},
			},
			permissions: {
				onDelete: () => this.authStore.hasPermission('fulfillmentOrderSection.delete'),
				onPrintBulkHistory: () => this.authStore.hasPermission('fulfillmentOrderSection.read'),
			},
			routes: {},
		});
		makeObservable(this);
		this.queryUtility.initialize(this.findBulkPrintHistory);
		this.modalParams = modalParams;
		this.initialize();
	}

	@action.bound
	initialize = () => {
		if (this.modalParams.data != null) {
			this.form.$('name').value = this.generateBulkPrintHistoryName();
		}
	};

	generateBulkPrintHistoryName = () => {
		const dateTime = moment()
			.tz('America/New_York')
			.format('MM/DD HH:mm A');
		const user = this.rootStore.authStore.user.displayName;
		return `${dateTime} - ${user}`;
	};

	@action.bound setAsChanged() {
		this.change = !this.change;
	}

	@action.bound async findBulkPrintHistory() {
		this.suspend();
		this.queryUtility.setFilterParams(this);
		await this.listStore.findBulkPrintHistory(this.queryUtility.filter);
		if (this.listStore.response.item.length === 0 && this.listStore.response.page !== 1) {
			await this.queryUtility.changePage(1);
		}
		this.queryUtility.handleResponse(this.listStore.response);
		this.resume();
	}

	@action.bound async deleteBulkPrintHistory(bhp) {
		this.suspend();
		try {
			await this.listStore.deleteBulkPrintHistory(bhp);
			this.rootStore.notificationStore.success(['LOOKUPDELETE.BULKPRINTHISTORY', { name: bhp.name }]);
			await this.queryUtility.initialize(false);
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	}

	@action.bound async printBulkHistory(item) {
		try {
			await this.listStore.printBulkPrintHistory(item.id, sourceOfChange.printBulkPrintHistoryItem);
			if (this.listStore.item) {
				if (this.listStore.item.data.failedCount > 0 && this.listStore.item.data.labels != '') {
					this.rootStore.notificationStore.error('FULFILLMENTORDER.BULKPRINT.PARTIALYPRINTED');
				}
				if (this.listStore.item.data.labels === '') {
					this.rootStore.notificationStore.error('FULFILLMENTORDER.BULKPRINT.EMPTY');
				} else {
					this.pdfURL = createFileUrl(this.listStore.item.data.labels);
					this.rootStore.notificationStore.success(['FULFILLMENTORDER.BULKPRINT.PRINTED']);
				}
			} else {
				this.rootStore.notificationStore.success(['FULFILLMENTORDER.BULKPRINT.NOORDERSTOPRINT']);
			}
			this.printPdf = true;
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.modalParams.data.printHistoryCallback({ pdfURL: this.pdfURL, printPdf: this.printPdf });
	}

	getDeleteConfirmModalProps = item => {
		return {
			onConfirm: async () => await this.deleteBulkPrintHistory(this.rootStore.viewStore.selectedConfirmModal.data),
			message: ['LOOKUPDELETECONFIRM.BULKPRINTHISTORY', { name: item.name }],
			data: item,
		};
	};

	@action.bound
	createBulkPrintHistory = async () => {
		try {
			var bphitem = this.modalParams.data;
			bphitem.name = this.form.$('name').value;
			await this.listStore.createBulkPrintHistory(bphitem, sourceOfChange.createBulkPrintHistoryItem);
			this.rootStore.notificationStore.success(['FULFILLMENTORDER.BULKPRINT.CREATED', { name: bphitem.name }]);
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	};
}

export default BulkPrintHistoryViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/BulkPrintHistoryViewStore.js